<template>
  <section id="sign-in" class="bglight position-relative padding">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center wow fadeIn" data-wow-delay="300ms">
          <h2 class="heading bottom30 darkcolor font-light2">
            <span class="font-normal">Verifikasi</span> Akun
            <span class="divider-center"></span>
          </h2>
          <div class="col-md-8 offset-md-2 heading_space">
            <p>
              <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A
              dolores explicabo laudantium, omnis provident quam reiciendis
              voluptatum? -->
            </p>
          </div>
        </div>

        <div class="col-lg-12 pl-lg-0 col-md-12 whitebox noshadow">
          <b-overlay :show="loadingCard" rounded="sm">
            <div class="widget logincontainer">
              <!-- <h3 class="darkcolor bottom30 text-center text-lg-left">Sign In</h3> -->
              <div class="row" v-if="!loadingCard && !successRegister">
                <div class="col-md-12 col-sm-12 text-center">
                  <img src="/img/comp-3-unscreen.gif" alt="" />
                </div>
                <div class="col-md-12 col-sm-12 text-center">
                  <h3 class="darkcolor bottom30 text-center text-danger">
                    Link Tidak Valid !
                  </h3>
                  <p class="text-center">
                    Link yang anda gunakan tidak valid, Silahkan cek kembali
                    email anda
                  </p>
                </div>
              </div>
              <div class="row" v-if="!loadingCard && successRegister">
                <div class="col-md-12 col-sm-12 text-center">
                  <img src="/img/success-2.gif" alt="" />
                </div>
                <div class="col-md-12 col-sm-12 text-center">
                  <h3 class="darkcolor bottom30 text-center text-success">
                    Selamat, Akun anda telah terverifikasi !
                  </h3>
                  <a
                    href="/login"
                    class="mx-4 btn btn-warning bg-custom fw-bold"
                    ><strong> Login </strong></a
                  >
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>
  </section>
</template>


<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth";

export default defineComponent({
  setup() {
    const loadingCard = ref(true);
    const successRegister = ref(false);
    const route = useRoute();
    const token = ref("");
    const authStore = useAuthStore();

    onMounted(async () => {
      token.value = route.query.verification_code as string;
      await  authStore.verifyEmail(token.value).then((res) => {
        loadingCard.value = false;
        successRegister.value = true;
      }).catch((err) => {
        loadingCard.value = false;
        successRegister.value = false;
      });
    });

    const getVerify =async () => {
      
    }

    return {
      loadingCard,
      successRegister,
    };
  },
});
</script>

